import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import CardHeader from "../../../components/common/CardHeader";
import "../premium.css";

/** Wspólny nagłówek, kontekst firmy i akcje zgodne z ekranami eCO. */
export default function PremiumLayout({ title, subtitle, actions, children }) {
  const section = useRef(null);
  const { pathname } = useLocation();
  useEffect(() => {
    section.current?.scrollIntoView({ block: "start" });
  }, [pathname]);
  return (
    <section className="premium-shell" ref={section}>
      <div className="premium-page-header">
        <div className="premium-heading-row">
          <div>
            <CardHeader text={title} onlyText />
            {subtitle && <p className="premium-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="premium-button-group">{actions}</div>}
        </div>
      </div>
      <div className="premium-workspace">{children}</div>
    </section>
  );
}
